var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel fz_info" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "panel-container" }, [
      _c(
        "div",
        {
          staticClass: "steps_ panel-content",
          staticStyle: { "min-height": "150px" },
        },
        [
          _c(
            "b-overlay",
            { staticClass: "pt-2 pb-2", attrs: { show: !_vm.is_load } },
            [
              _vm.is_load
                ? _c("div", { staticClass: "skd" }, [
                    _vm.obj_to_null(this.gw_item.cards)
                      ? _c("div", { staticClass: "uporx_cards" }, [
                          _c("h4", { staticClass: "pt-2 pb-2" }, [
                            _vm._v("Картки"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(this.gw_item.cards, function (card) {
                              return _c(
                                "li",
                                {
                                  staticStyle: {
                                    clear: "both",
                                    "margin-bottom": "12px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "id" }, [
                                    _vm._v(
                                      "GUID : " + _vm._s(card.card_guid) + " "
                                    ),
                                    _c(
                                      "small",
                                      { staticStyle: { float: "right" } },
                                      [
                                        _vm._v(
                                          "Назва:\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(card.card_name)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v("CARD_STATUS"),
                                    _c(
                                      "small",
                                      { staticStyle: { float: "right" } },
                                      [_vm._v(_vm._s(card.card_status_h))]
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.obj_to_null(this.gw_item.acc_rules)
                      ? _c("div", { staticClass: "uporx_cards" }, [
                          _c("h4", { staticClass: "pt-2 pb-2" }, [
                            _vm._v("СКД пункти"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(this.gw_item.acc_rules, function (rule) {
                              return _c(
                                "li",
                                {
                                  staticStyle: {
                                    clear: "both",
                                    "margin-bottom": "12px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "id" }, [
                                    _vm._v("Пункт : "),
                                    _c(
                                      "small",
                                      { staticStyle: { float: "right" } },
                                      [_vm._v(_vm._s(rule.group_name))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "small",
                                      { staticStyle: { float: "right" } },
                                      [_vm._v(_vm._s(rule.name))]
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAccessDoorList
                      ? _c("div", { staticClass: "uporx_cards" }, [
                          _c("h4", { staticClass: "pt-2 pb-2" }, [
                            _vm._v("Доступ на в'їзд і виїзд (door_tokens):"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            [
                              _vm._l(_vm.accessDoorList, function (door) {
                                return _c(
                                  "li",
                                  {
                                    staticClass: "id",
                                    staticStyle: {
                                      clear: "both",
                                      "margin-bottom": "12px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-100 d-flex flex-row flex-nowrap align-items-center justify-content-between",
                                        staticStyle: { gap: "12px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-column flex-nowrap",
                                          },
                                          [
                                            _c("div", { staticClass: "id" }, [
                                              _vm._v(
                                                "TOKEN : " +
                                                  _vm._s(door?.token ?? "")
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "id" }, [
                                              _vm._v(
                                                "TOKEN_IN : " +
                                                  _vm._s(door?.token_in ?? "")
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "id" }, [
                                              _vm._v(
                                                "TOKEN_OUT : " +
                                                  _vm._s(door?.token_out ?? "")
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(
                                            "Назва: " + _vm._s(door?.name ?? "")
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "id",
                                  staticStyle: {
                                    clear: "both",
                                    "margin-bottom": "12px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 d-flex flex-row flex-nowrap align-items-center justify-content-between",
                                      staticStyle: { gap: "12px" },
                                    },
                                    [
                                      _c("div", { staticClass: "id" }, [
                                        _vm._v("Дата початку дії доступу:"),
                                      ]),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(_vm._s(_vm.dateStartAccess)),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "id",
                                  staticStyle: {
                                    clear: "both",
                                    "margin-bottom": "12px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 d-flex flex-row flex-nowrap align-items-center justify-content-between",
                                      staticStyle: { gap: "12px" },
                                    },
                                    [
                                      _c("div", { staticClass: "id" }, [
                                        _vm._v("Дата кінця дії доступу:"),
                                      ]),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(_vm._s(_vm.dateStopAccess)),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "id",
                                  staticStyle: {
                                    clear: "both",
                                    "margin-bottom": "12px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-row flex-nowrap align-items-center",
                                      staticStyle: { gap: "12px" },
                                    },
                                    [
                                      _c("div", { staticClass: "id" }, [
                                        _vm._v("Коментар:"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "ms-2 ps-2 text-wrap" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.commentAccess) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "panel-hdr bg-primary-500 bg-success-gradient" },
      [
        _c("h2", [
          _c("span", { staticClass: "icon-stack fs-xxl mr-2" }, [
            _c("i", {
              staticClass:
                "base base-7 icon-stack-3x opacity-100 color-primary-500",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "base base-7 icon-stack-2x opacity-100 color-primary-400",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "fal fa-podcast icon-stack-1x opacity-100 color-white fa-spin",
            }),
          ]),
          _vm._v("\n\t\t\t\tСКД\n\t\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar" }, [
          _c("button", {
            staticClass: "btn btn-panel waves-effect waves-themed",
            attrs: {
              "data-action": "panel-fullscreen",
              "data-toggle": "tooltip",
              "data-offset": "0,10",
              "data-original-title": "Fullscreen",
            },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }